export enum MutationList {
    SET_INITIAL_NAVIGATION_VALUES = 'SET_INITIAL_NAVIGATION_VALUES',
    SET_INITIAL_INTRODUCTION_CONTENT = 'SET_INITIAL_INTRODUCTION_CONTENT'
}